import { useEffect, useState } from "react";
import { api } from "../lib/api";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

export default function Faq() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="faq-page" className="text-white">
      <section className="max-w-4xl mx-auto px-5 md:px-8 pt-16 md:pt-24">
        <div className="text-xs uppercase tracking-[0.35em] text-axe-tangerine font-bold">
          Community
        </div>
        <h1 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl">
          AXE <span className="text-axe-purple">FAQ</span>
        </h1>
        <p className="mt-5 text-neutral-400 text-base sm:text-lg">
          Quick answers to the questions we get the most.
        </p>
      </section>

      <section className="max-w-4xl mx-auto px-5 md:px-8 mt-12 pb-20">
        {loading ? (
          <div className="text-neutral-400">Loading…</div>
        ) : faqs.length === 0 ? (
          <div className="text-neutral-500 border border-axe-border rounded-2xl p-8 text-center">No FAQs yet.</div>
        ) : (
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={f.id}
                value={f.id}
                className="rounded-2xl border border-axe-border bg-axe-surface px-5 data-[state=open]:border-axe-purple/60"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display font-semibold text-lg text-white hover:no-underline">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-neutral-300 leading-relaxed text-base">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        )}
      </section>
    </div>
  );
}
